// extracted by mini-css-extract-plugin
export default {"crossButtonClassName":"sidebar_crossButtonClassName__VZpew"};